import React, {useEffect, useState} from 'react';
import Link from 'next/link';
import {closeMblMenu, loginModalShow} from '../../redux/counterSlice';
import {useAppSelector, useAppDispatch} from '../../redux/hooks';
import {useRouter} from 'next/router';
import {notifySignout} from '../common/toast';
import Image from 'next/image';
import {useDisconnect} from 'wagmi';
import {clearWalletConnectCache} from '../walletConnect';
import {useTranslation} from 'react-i18next';
import {useApp} from '../providers/app-provider';
import Notification from './notification';
import {SuggestionDropdown} from '../search/suggestion_dropdown';
import {Role} from '@api/user';

function useWindowSize() {
  const [windowSize, setWindowSize] = useState<{width?: number}>({
    width: undefined,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
      });
    }

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

const MblNavbar = ({theme}: any) => {
  const {setLoginShow} = useApp();
  const {t} = useTranslation(['header']);
  const {mblMenu} = useAppSelector((state) => state.counter);
  const dispatch = useAppDispatch();
  const [profileShow, setProfileShow] = useState(true);
  const [showSuggestion, setShowSuggestion] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [isCreateActive, setIsCreateActive] = useState(false);
  const router = useRouter();
  const disconnectWalletConnect = useDisconnect();
  const {jwt: token, user, setModalOpen, setJWT, setLanguage, language} = useApp();
  const [search, setSearch] = useState('');

  const signOut = () => {
    setJWT && setJWT(null);
    disconnectWalletConnect; // delete walletConnect cache
    clearWalletConnectCache();
    router.push('/');
  };

  const openDropdown = (e: any) => {
    setIsActive(true);
    setProfileShow(false);
  };

  const closeDropdown = (e: any) => {
    setIsActive(false);
    setProfileShow(true);
  };

  useEffect(() => {
    if (search !== '') setShowSuggestion(true);
    else setShowSuggestion(false);
  }, [search]);

  const removeSearch = () => {
    setSearch('');
  };

  const windowSize = useWindowSize();
  const mobileWidth = 1024;
  return (
    <>
      <div
        className={
          mblMenu
            ? 'js-mobile-menu dark:bg-dark-navy invisible fixed inset-0 z-50 ml-auto items-center bg-white opacity-0 lg:visible lg:relative lg:inset-auto lg:flex lg:bg-transparent lg:opacity-100 dark:lg:bg-transparent nav-menu--is-open'
            : 'js-mobile-menu dark:bg-dark-navy invisible fixed inset-0 z-50 ml-auto items-center bg-white opacity-0 lg:visible lg:relative lg:inset-auto lg:flex lg:bg-transparent lg:opacity-100 dark:lg:bg-transparent'
        }
      >
        {/* create btn on mobile menu */}
        {(windowSize.width as number) <= mobileWidth && isCreateActive ? (
          <div
            className=" dark:bg-dark-navy invisible 
          fixed inset-0 z-50 ml-auto items-center bg-white opacity-0 lg:visible 
          lg:relative lg:inset-auto lg:flex lg:bg-transparent lg:opacity-100 dark:lg:bg-transparent !p-0 nav-menu--is-open"
          >
            <a className="fixed pl-2 py-3 " onClick={() => setIsCreateActive(false)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1em"
                height="1em"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="m10.875 19.3l-6.6-6.6q-.15-.15-.213-.325Q4 12.2 4 12t.062-.375q.063-.175.213-.325l6.6-6.6q.275-.275.687-.288q.413-.012.713.288q.3.275.313.687q.012.413-.288.713L7.4 11h11.175q.425 0 .713.287q.287.288.287.713t-.287.712Q19 13 18.575 13H7.4l4.9 4.9q.275.275.288.7q.012.425-.288.7q-.275.3-.7.3q-.425 0-.725-.3Z"
                />
              </svg>
            </a>
            <div className="mt-12">
              {token ? (
                <Link href="/collection/create">
                  <a
                    onClick={() => dispatch(closeMblMenu())}
                    className="flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors "
                  >
                    <span className="font-display dark:text-white text-jacarta-700 mt-1 text-base ">
                      {t('header:menu.create-collection')}
                    </span>
                  </a>
                </Link>
              ) : (
                <a
                  onClick={() => {
                    dispatch(loginModalShow());
                    setIsCreateActive(false);
                  }}
                  className="flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors cursor-pointer"
                >
                  <span className="font-display dark:text-white text-jacarta-700 mt-1 text-base">
                    {t('header:menu.create-collection')}
                  </span>
                </a>
              )}
              {token ? (
                <Link href="/create">
                  <a
                    onClick={() => dispatch(closeMblMenu())}
                    className="flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors "
                  >
                    <span className="font-display dark:text-white text-jacarta-700 mt-4 text-base">
                      {t('header:menu.create-item')}
                    </span>
                  </a>
                </Link>
              ) : (
                <a
                  onClick={() => {
                    setLoginShow && setLoginShow(true);
                    setIsCreateActive(false);
                  }}
                  className=" flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors cursor-pointer"
                >
                  <span className="font-display dark:text-white text-jacarta-700 mt-4 text-base">
                    {t('header:menu.create-item')}
                  </span>
                </a>
              )}
              {token &&
                user &&
                (user.roles?.includes(Role.ADMIN) || user.roles?.includes(Role.SUPER_ADMIN)) && (
                  <Link href="/collection/import">
                    <a
                      onClick={() => {
                        dispatch(closeMblMenu());
                        localStorage.setItem('navItemValue', '28');
                      }}
                      className=" flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors cursor-pointer"
                    >
                      <span className="font-display dark:text-white text-jacarta-700 mt-4 text-base">
                        {t('header:menu.import')}
                      </span>
                    </a>
                  </Link>
                )}
              {!token && (
                <a
                  onClick={() => {
                    setLoginShow && setLoginShow(true);
                    setIsCreateActive(false);
                  }}
                  className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors cursor-pointer"
                >
                  <span className="font-display dark:text-white text-jacarta-700 mt-4 text-base">
                    {t('header:menu.import')}
                  </span>
                </a>
              )}
            </div>
          </div>
        ) : null}
        <div className="t-0 dark:bg-dark-navy fixed left-0 z-10 flex w-full items-center justify-between bg-white p-6 lg:hidden">
          {/* <!-- Mobile Logo --> */}

          <Link href="/">
            <a className="flex items-center">
              <img
                src="/images/logo-light.png"
                className="max-h-7 dark:hidden"
                alt="Nusa | NFT Marketplace"
              />

              <img
                src="/images/logo-dark.png"
                alt="Nusa | NFT Marketplace"
                className="max-h-7 dark:block hidden"
              />
              {/*
              <div className="font-bold dark:text-green-2 bg-grey/[0.3] ml-2 text-[10px] tracking-wide px-2 py-[2px] h-full rounded-xl font-display">
                BETA
              </div>
              */}
            </a>
          </Link>

          {/* <!-- Mobile Menu Close --> */}
          <button
            className="fill-jacarta-700 h-4 w-4 transition-colors group-hover:fill-white group-focus:fill-white dark:fill-white"
            onClick={() => dispatch(closeMblMenu())}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              className="fill-dark-navy h-4 w-4 transition-colors group-hover:fill-white group-focus:fill-white dark:fill-white"
            >
              <path fill="none" d="M0 0h24v24H0z"></path>
              <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"></path>
            </svg>
          </button>
        </div>
        {/* <!-- Mobile Search --> */}
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setShowSuggestion(false);
            router.push({
              pathname: '/search',
              query: {
                q: search,
              },
            });
          }}
          action="search"
          className="relative mt-24 mb-8 w-full lg:hidden"
        >
          {/* <input type="search" className="text-dark-navy placeholder-jacarta-500 focus:ring-accent border-jacarta-100 w-full rounded-2xl border py-3 px-4 pl-10 dark:border-transparent dark:bg-white/[.15] dark:text-white dark:placeholder-white" placeholder="Search"> */}
          <input
            type="search"
            className="text-dark-navy placeholder-jacarta-500 focus:ring-green border-jacarta-100 w-full rounded-2xl border py-[0.6875rem] px-10 dark:border-transparent dark:bg-white/[.15] dark:text-white dark:placeholder-white"
            placeholder={t('header:menu.search') ?? ''}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <span className="absolute left-0 top-0 flex h-full w-12 items-center justify-center rounded-2xl">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              className="fill-jacarta-500 h-4 w-4 dark:fill-white"
            >
              <path fill="none" d="M0 0h24v24H0z"></path>
              <path d="M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15z"></path>
            </svg>
          </span>
          {search !== '' && (
            <span
              className="absolute right-0 top-0 flex h-full w-12 items-center justify-center rounded-2xl cursor-pointer"
              onClick={removeSearch}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
                className="fill-jacarta-500 h-4 w-4 dark:fill-white"
              >
                <g clipPath="url(#clip0_1415_32214)">
                  <path d="M10.8164 9.97248L14.8664 5.92248C14.9574 5.8162 15.005 5.67949 14.9996 5.53967C14.9942 5.39985 14.9362 5.26722 14.8373 5.16827C14.7383 5.06933 14.6057 5.01137 14.4659 5.00597C14.3261 5.00057 14.1894 5.04813 14.0831 5.13914L10.0331 9.18914L5.98308 5.13359C5.8768 5.04257 5.74009 4.99501 5.60027 5.00041C5.46045 5.00581 5.32782 5.06378 5.22888 5.16272C5.12994 5.26166 5.07197 5.39429 5.06657 5.53411C5.06117 5.67393 5.10873 5.81064 5.19975 5.91692L9.24975 9.97248L5.19419 14.0225C5.13603 14.0723 5.0888 14.1336 5.05545 14.2025C5.02211 14.2714 5.00337 14.3465 5.00041 14.423C4.99746 14.4995 5.01035 14.5758 5.03828 14.6471C5.06621 14.7184 5.10858 14.7831 5.16272 14.8373C5.21686 14.8914 5.28161 14.9338 5.3529 14.9617C5.42419 14.9896 5.50049 15.0025 5.577 14.9996C5.65351 14.9966 5.72858 14.9779 5.79751 14.9445C5.86643 14.9112 5.92772 14.864 5.97752 14.8058L10.0331 10.7558L14.0831 14.8058C14.1894 14.8968 14.3261 14.9444 14.4659 14.939C14.6057 14.9336 14.7383 14.8756 14.8373 14.7767C14.9362 14.6777 14.9942 14.5451 14.9996 14.4053C15.005 14.2655 14.9574 14.1288 14.8664 14.0225L10.8164 9.97248Z" />
                </g>
                <defs>
                  <clipPath id="clip0_1415_32214">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
          )}
          {/* Dropdown Suggestion */}
          <SuggestionDropdown isOpen={showSuggestion} search={search} />
        </form>
        {/* <!-- Primary Nav --> */}
        <nav className="navbar w-full">
          <ul className="flex flex-col lg:flex-row">
            <li className="group">
              <Link href="/collection/explore-collection">
                <a
                  onClick={() => {
                    dispatch(closeMblMenu());
                    localStorage.setItem('navItemValue', '28');
                  }}
                >
                  <button className="text-dark-navy font-display hover:text-green focus:text-green dark:hover:text-green dark:focus:text-green flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                    <span>{t('header:menu.explore')}</span>
                  </button>
                </a>
              </Link>
            </li>
            <li className="group relative">
              <a
                onClick={() => {
                  setIsCreateActive(!isCreateActive);
                  localStorage.setItem('navItemValue', '28');
                }}
              >
                <button className="text-dark-navy font-display gap-6 hover:text-green focus:text-green dark:hover:text-green dark:focus:text-green flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                  <span>{t('header:menu.create')}</span>
                  <div className="fixed right-8">
                    {(windowSize.width as number) <= mobileWidth ? <span>&#x3e;</span> : null}
                  </div>
                </button>
              </a>
              <div
                className={` 
                dropdown-menu dark:bg-dark-navy
                !-right-4 !top-[70%] !left-auto z-10
                min-w-[14rem] whitespace-nowrap
                rounded-xl bg-white
                transition-all will-change-transform
                before:absolute before:-top-3 before:h-3 before:w-full
                lg:absolute lg:!translate-y-4 lg:py-4 lg:px-2
                lg:shadow-2xl hidden lg:grid
                ${/** These classes handle hover states */ ''}
                group-hover:opacity-100 group-hover:visible
                lg:invisible lg:opacity-0 `}
              >
                {token ? (
                  <Link href="/collection/create">
                    <a
                      onClick={() => dispatch(closeMblMenu())}
                      className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors "
                    >
                      <span className="font-display dark:text-white text-jacarta-700 mt-1 text-sm">
                        {t('header:menu.create-collection')}
                      </span>
                    </a>
                  </Link>
                ) : (
                  <a
                    onClick={() => {
                      setLoginShow && setLoginShow(true);
                      setIsCreateActive(false);
                    }}
                    className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors cursor-pointer"
                  >
                    <span className="font-display dark:text-white text-jacarta-700 mt-1 text-sm">
                      {t('header:menu.create-collection')}
                    </span>
                  </a>
                )}
                {token ? (
                  <Link href="/create">
                    <a
                      onClick={() => dispatch(closeMblMenu())}
                      className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors "
                    >
                      <span className="font-display dark:text-white text-jacarta-700 mt-1 text-sm">
                        {t('header:menu.create-item')}
                      </span>
                    </a>
                  </Link>
                ) : (
                  <a
                    onClick={() => {
                      setLoginShow && setLoginShow(true);
                      setIsCreateActive(false);
                    }}
                    className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors cursor-pointer"
                  >
                    <span className="font-display dark:text-white text-jacarta-700 mt-1 text-sm">
                      {t('header:menu.create-item')}
                    </span>
                  </a>
                )}
                {token &&
                  user &&
                  (user.roles?.includes(Role.ADMIN) || user.roles?.includes(Role.SUPER_ADMIN)) && (
                    <Link href="/collection/import">
                      <a
                        onClick={() => {
                          dispatch(closeMblMenu());
                          localStorage.setItem('navItemValue', '28');
                        }}
                      >
                        <button className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors cursor-pointer">
                          <span className="font-display dark:text-white text-jacarta-700 mt-1 text-sm">
                            {t('header:menu.import')}
                          </span>
                        </button>
                      </a>
                    </Link>
                  )}
                {!token && (
                  <a
                    onClick={() => {
                      setLoginShow && setLoginShow(true);
                      setIsCreateActive(false);
                    }}
                    className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors cursor-pointer"
                  >
                    <span className="font-display dark:text-white text-jacarta-700 mt-1 text-sm">
                      {t('header:menu.import')}
                    </span>
                  </a>
                )}
              </div>
            </li>
            <li className="group">
              <Link href={token ? '/redeem' : '#'} legacyBehavior>
                <a
                  onClick={() => {
                    if (!token) {
                      setLoginShow && setLoginShow(true);
                      return;
                    }
                    dispatch(closeMblMenu());
                    localStorage.setItem('navItemValue', '28');
                  }}
                >
                  <button className="text-dark-navy font-display hover:text-green focus:text-green dark:hover:text-green dark:focus:text-green flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                    <span>{t('header:menu.redeem')}</span>
                  </button>
                </a>
              </Link>
            </li>
          </ul>
        </nav>
        {/* <!-- Mobile Connect Wallet / Socials --> */}
        <div className="mt-10 w-full lg:hidden ">
          <div className={token ? 'hidden' : 'block'}>
            <button
              onClick={() => setLoginShow && setLoginShow(true)}
              className="js-wallet bg-gradient-to-br from-green-3 to-green-2  block w-full rounded-full py-3 px-8 text-center font-semibold text-white transition-all"
            >
              Connect Wallet
            </button>
          </div>
          <hr className="dark:bg-jacarta-600 bg-jacarta-100 my-5 h-px border-0" />

          {/* <!-- Socials --> */}
          <div className="flex items-center justify-center space-x-5">
            <a href="#" className="group">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fab"
                data-icon="facebook"
                className=" fill-jacarta-300 h-5 w-5 dark:group-hover:fill-white"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"></path>
              </svg>
            </a>
            <a href="#" className="group">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fab"
                data-icon="twitter"
                className=" fill-jacarta-300 h-5 w-5 dark:group-hover:fill-white"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"></path>
              </svg>
            </a>
            <a href="#" className="group">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fab"
                data-icon="discord"
                className=" fill-jacarta-300 h-5 w-5 dark:group-hover:fill-white"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 640 512"
              >
                <path d="M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"></path>
              </svg>
            </a>
            <a href="#" className="group">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fab"
                data-icon="instagram"
                className=" fill-jacarta-300 h-5 w-5 dark:group-hover:fill-white"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
              >
                <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path>
              </svg>
            </a>
            <a href="#" className="group">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fab"
                data-icon="tiktok"
                className=" fill-jacarta-300 h-5 w-5 dark:group-hover:fill-white"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
              >
                <path d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"></path>
              </svg>
            </a>
          </div>
        </div>
        {/* <!-- Actions --> */}
        <div className="ml-8 hidden lg:flex gap-2 xl:ml-12">
          {/* <!-- Profile --> */}

          <div className={token ? 'js-nav-dropdown group-dropdown relative' : 'relative'}>
            <button
              className="dropdown-toggle border-jacarta-100 ml-2 flex h-10 w-10 overflow-hidden items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15]"
              onClick={() => {
                !token ? setLoginShow && setLoginShow(true) : null;
              }}
            >
              {token ? (
                <Image
                  src={
                    user?.profile_picture
                      ? `${process.env.NEXT_PUBLIC_UPLOAD_URL}${user?.profile_picture}`
                      : '/images/user/user_avatar_new.png'
                  }
                  alt={`${user?.first_name} ${user?.last_name}`}
                  width={50}
                  height={50}
                  objectFit={'cover'}
                  className="rounded-full "
                  unoptimized
                ></Image>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  className="fill-jacarta-700 h-4 w-4 transition-colors group-hover:fill-white group-focus:fill-white dark:fill-white"
                >
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path d="M11 14.062V20h2v-5.938c3.946.492 7 3.858 7 7.938H4a8.001 8.001 0 0 1 7-7.938zM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6z"></path>
                </svg>
              )}
            </button>

            <div
              className={
                profileShow
                  ? 'dropdown-menu dark:bg-dark-navy group-dropdown-hover:opacity-100 group-dropdown-hover:visible !-right-4 !top-[85%] !left-auto z-50 min-w-[14rem] whitespace-nowrap rounded-xl bg-white before:absolute before:-top-3 before:h-3 before:w-full lg:absolute lg:grid lg:!translate-y-4 lg:py-4 lg:px-2 lg:shadow-2xl show lg:invisible lg:opacity-100 '
                  : 'dropdown-menu dark:bg-dark-navy group-dropdown-hover:opacity-100 group-dropdown-hover:invisible !-right-4 !top-[85%] !left-auto z-50 min-w-[14rem] whitespace-nowrap rounded-xl bg-white before:absolute before:-top-3 before:h-3 before:w-full lg:absolute lg:grid lg:!translate-y-4 lg:py-4 lg:px-2 lg:shadow-2xl hidden lg:invisible lg:opacity-100'
              }
            >
              <Link href={`/user/${user ? user.wallet_address : ''}`}>
                <a className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    className="fill-jacarta-700 h-4 w-4 transition-colors dark:fill-white"
                  >
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M11 14.062V20h2v-5.938c3.946.492 7 3.858 7 7.938H4a8.001 8.001 0 0 1 7-7.938zM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6z"></path>
                  </svg>
                  <span className="font-display dark:text-white text-jacarta-700 mt-1 text-sm">
                    {t('header:profile-menu.my-profile')}
                  </span>
                </a>
              </Link>
              <Link href={`/user/${user ? user.wallet_address : ''}?activeTab=3#user-items`}>
                <a
                  // onClick={() => dispatch(setTabActive(3))}
                  className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    className="fill-jacarta-700 h-4 w-4 transition-colors dark:fill-white"
                  >
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M12.07937 13.5904C8.4716 14.1378 7.53596 14.1378 6.92819 13.5825L6.84023 13.5032C2.64184 9.7348 -0.101104 7.26751 0.00285575 4.18935C0.0508373 2.84068 0.74657 1.54753 1.87414 0.785926C3.98532 -0.642086 6.59232 0.0243193 7.99978 1.6586C9.40724 0.0243193 12.0142 -0.65002 14.1254 0.785926C15.253 1.54753 15.9487 2.84068 15.9967 4.18935C16.1087 7.26751 13.3577 9.7348 9.15934 13.519L9.07937 13.5904Z" />{' '}
                  </svg>
                  <span className="font-display dark:text-white text-jacarta-700 mt-1 text-sm">
                    {t('header:profile-menu.favorites')}
                  </span>
                </a>
              </Link>
              <Link href="/watchlist">
                <a className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    className="fill-jacarta-700 h-4 w-4 transition-colors dark:fill-white"
                  >
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M10.3979 4.99895C10.3979 6.32491 9.32239 7.39981 7.99565 7.39981C6.66893 7.39981 5.59341 6.32491 5.59341 4.99895C5.59341 3.67298 6.66893 2.59809 7.99565 2.59809C9.32239 2.59808 10.3979 3.67299 10.3979 4.99895ZM8 0C6.62633 0.00635641 5.20248 0.355208 3.85461 1.0231C2.85384 1.53943 1.87853 2.2679 1.03192 3.16705C0.616107 3.62603 0.0857467 4.29063 0 4.99973C0.0101333 5.61396 0.641733 6.37212 1.03192 6.83242C1.82583 7.69625 2.77573 8.40439 3.85461 8.9769C5.11156 9.61325 6.50283 9.97962 8 10C9.37497 9.99355 10.7985 9.64067 12.1449 8.9769C13.1457 8.46057 14.1215 7.73157 14.9681 6.83242C15.3839 6.37344 15.9142 5.70882 16 4.99973C15.9899 4.38549 15.3583 3.62731 14.9681 3.16702C14.1742 2.30319 13.2238 1.5956 12.1449 1.02308C10.8886 0.387213 9.49389 0.0233532 8 0ZM7.99899 1.24135C10.0806 1.24135 11.768 2.92426 11.768 5.00027C11.768 7.07627 10.0806 8.75918 7.99899 8.75918C5.9174 8.75918 4.22999 7.07626 4.22999 5.00027C4.22999 2.92426 5.9174 1.24135 7.99899 1.24135Z" />{' '}
                  </svg>
                  <span className="font-display dark:text-white text-jacarta-700 mt-1 text-sm">
                    {t('header:profile-menu.watchlist')}
                  </span>
                </a>
              </Link>
              <Link href="/collection/my-collection">
                <a className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    className="fill-jacarta-700 h-4 w-4 transition-colors dark:fill-white"
                  >
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M13.4991 5.00118C14.1336 5.00106 14.7444 5.24225 15.2077 5.67584C15.671 6.10943 15.9521 6.70298 15.994 7.33614L16 7.50014V13.5C16.0001 14.1347 15.7588 14.7457 15.325 15.2091C14.8912 15.6724 14.2974 15.9534 13.6641 15.995L13.5001 16H7.50024C6.86554 16.0001 6.25456 15.7588 5.79124 15.325C5.32792 14.8912 5.04694 14.2974 5.00531 13.664L5.00031 13.5V7.50014C5.00021 6.86543 5.24153 6.25445 5.67533 5.79112C6.10912 5.32779 6.70291 5.04682 7.33624 5.00518L7.49924 5.00118H13.4991ZM10.5002 7.00115C10.3831 7.00111 10.2698 7.04212 10.1799 7.11703C10.09 7.19195 10.0292 7.29603 10.0082 7.41114L10.0002 7.50114V10.0011H7.49924L7.40924 10.0081C7.29396 10.029 7.18967 10.0897 7.11457 10.1796C7.03947 10.2695 6.99834 10.3829 6.99834 10.5001C6.99834 10.6172 7.03947 10.7307 7.11457 10.8206C7.18967 10.9105 7.29396 10.9712 7.40924 10.9921L7.49924 11.0001H9.99917V13.5L10.0072 13.59C10.028 13.7053 10.0887 13.8096 10.1786 13.8847C10.2686 13.9598 10.382 14.0009 10.4992 14.0009C10.6163 14.0009 10.7297 13.9598 10.8197 13.8847C10.9096 13.8096 10.9703 13.7053 10.9911 13.59L10.9991 13.501V11.0011H13.4991L13.5891 10.9931C13.7043 10.9722 13.8086 10.9115 13.8837 10.8216C13.9588 10.7317 14 10.6182 14 10.5011C14 10.3839 13.9588 10.2705 13.8837 10.1806C13.8086 10.0907 13.7043 10.03 13.5891 10.0091L13.4991 10.0011H10.9991V7.50114L10.9911 7.41114C10.9701 7.29603 10.9093 7.19195 10.8194 7.11703C10.7295 7.04212 10.6162 7.00111 10.4992 7.00115H10.5002ZM10.6621 1.69523L10.7101 1.85323L11.2851 4.00019H7.00025C6.23506 4.00015 5.49878 4.29251 4.94205 4.81746C4.38532 5.34241 4.05023 6.06027 4.00533 6.82415L4.00033 7.00015V12.3481C3.48953 12.337 2.99436 12.1697 2.58141 11.8689C2.16846 11.568 1.85752 11.1479 1.6904 10.6651L1.6384 10.4951L0.0854429 4.70018C-0.0790753 4.08715 -0.00425691 3.4345 0.294721 2.8746C0.5937 2.31471 1.09445 1.8895 1.6954 1.68523L1.85339 1.63823L7.64823 0.0852586C8.23409 -0.0717936 8.85707 -0.0104899 9.40108 0.257747C9.94509 0.525984 10.373 0.982857 10.6052 1.54323L10.6621 1.69523V1.69523Z" />
                  </svg>
                  <span className="font-display dark:text-white text-jacarta-700 mt-1 text-sm">
                    {t('header:profile-menu.my-collection')}
                  </span>
                </a>
              </Link>
              <a
                onClick={() => setModalOpen && setModalOpen(true)}
                className=" dark:hover:bg-jacarta-600  focus:text-accent hover:bg-jacarta-50 flex items-center justify-between rounded-xl px-5 py-2 transition-colors cursor-pointer "
              >
                <div className="flex space-x-2">
                  <svg
                    className="fill-jacarta-700 h-4 w-4 transition-colors dark:fill-white"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M10.6842 4.53158C10.4263 4.38421 10.0947 4.38421 9.8 4.53158L7.73684 5.74737L6.33684 6.52105L4.31053 7.73684C4.05263 7.88421 3.72105 7.88421 3.42632 7.73684L1.84211 6.77895C1.58421 6.63158 1.4 6.33684 1.4 6.00526V4.16316C1.4 3.86842 1.54737 3.57369 1.84211 3.38947L3.42632 2.46842C3.68421 2.32105 4.01579 2.32105 4.31053 2.46842L5.89474 3.42632C6.15263 3.57369 6.33684 3.86842 6.33684 4.2V5.41579L7.73684 4.60526V3.35263C7.73684 3.0579 7.58947 2.76316 7.29474 2.57895L4.34737 0.847369C4.08947 0.700001 3.75789 0.700001 3.46316 0.847369L0.442105 2.61579C0.147368 2.76316 0 3.0579 0 3.35263V6.81579C0 7.11053 0.147368 7.40526 0.442105 7.58948L3.42632 9.32105C3.68421 9.46842 4.01579 9.46842 4.31053 9.32105L6.33684 8.14211L7.73684 7.33158L9.76316 6.15263C10.0211 6.00526 10.3526 6.00526 10.6474 6.15263L12.2316 7.07369C12.4895 7.22105 12.6737 7.51579 12.6737 7.84737V9.68948C12.6737 9.98421 12.5263 10.2789 12.2316 10.4632L10.6842 11.3842C10.4263 11.5316 10.0947 11.5316 9.8 11.3842L8.21579 10.4632C7.95789 10.3158 7.77368 10.0211 7.77368 9.68948V8.51053L6.37368 9.32105V10.5368C6.37368 10.8316 6.52105 11.1263 6.81579 11.3105L9.8 13.0421C10.0579 13.1895 10.3895 13.1895 10.6842 13.0421L13.6684 11.3105C13.9263 11.1632 14.1105 10.8684 14.1105 10.5368V7.03684C14.1105 6.74211 13.9632 6.44737 13.6684 6.26316L10.6842 4.53158Z" />
                  </svg>
                  <span className="font-display dark:text-white text-jacarta-700 mt-1 text-sm">
                    {t('header:profile-menu.wrap-matic')}
                  </span>
                </div>
              </a>
              <Link href="/user/edit">
                <a className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    className="fill-dark-navy h-4 w-4 transition-colors group-hover:fill-white group-focus:fill-white dark:fill-white"
                  >
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M9.954 2.21a9.99 9.99 0 0 1 4.091-.002A3.993 3.993 0 0 0 16 5.07a3.993 3.993 0 0 0 3.457.261A9.99 9.99 0 0 1 21.5 8.876 3.993 3.993 0 0 0 20 12c0 1.264.586 2.391 1.502 3.124a10.043 10.043 0 0 1-2.046 3.543 3.993 3.993 0 0 0-3.456.261 3.993 3.993 0 0 0-1.954 2.86 9.99 9.99 0 0 1-4.091.004A3.993 3.993 0 0 0 8 18.927a3.993 3.993 0 0 0-3.457-.26A9.99 9.99 0 0 1 2.5 15.121 3.993 3.993 0 0 0 4 11.999a3.993 3.993 0 0 0-1.502-3.124 10.043 10.043 0 0 1 2.046-3.543A3.993 3.993 0 0 0 8 5.071a3.993 3.993 0 0 0 1.954-2.86zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"></path>
                  </svg>
                  <span className="font-display dark:text-white text-jacarta-700 mt-1 text-sm">
                    {t('header:profile-menu.edit-profile')}
                  </span>
                </a>
              </Link>
              <a
                onClick={(e) => openDropdown(e)}
                className=" dark:hover:bg-jacarta-600  focus:text-accent hover:bg-jacarta-50 flex items-center justify-between rounded-xl px-5 py-2 transition-colors cursor-pointer "
              >
                <div className="flex space-x-2">
                  <svg
                    width="24"
                    height="24"
                    fill="white"
                    xmlns="http://www.w3.org/2000/svg"
                    className="fill-jacarta-700 h-4 w-4 transition-colors dark:fill-white"
                  >
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M7.9925 0.5C3.8525 0.5 0.5 3.86 0.5 8C0.5 12.14 3.8525 15.5 7.9925 15.5C12.14 15.5 15.5 12.14 15.5 8C15.5 3.86 12.14 0.5 7.9925 0.5ZM13.19 5H10.9775C10.7428 4.07109 10.3952 3.17442 9.9425 2.33C11.3106 2.801 12.4634 3.74879 13.19 5ZM8 2.03C8.6225 2.93 9.11 3.9275 9.4325 5H6.5675C6.89 3.9275 7.3775 2.93 8 2.03ZM2.195 9.5C2.075 9.02 2 8.5175 2 8C2 7.4825 2.075 6.98 2.195 6.5H4.73C4.67 6.995 4.625 7.49 4.625 8C4.625 8.51 4.67 9.005 4.73 9.5H2.195ZM2.81 11H5.0225C5.2625 11.9375 5.6075 12.8375 6.0575 13.67C4.68798 13.2016 3.53437 12.2531 2.81 11V11ZM5.0225 5H2.81C3.53437 3.74688 4.68798 2.79843 6.0575 2.33C5.60482 3.17442 5.25723 4.07109 5.0225 5V5ZM8 13.97C7.3775 13.07 6.89 12.0725 6.5675 11H9.4325C9.11 12.0725 8.6225 13.07 8 13.97ZM9.755 9.5H6.245C6.1775 9.005 6.125 8.51 6.125 8C6.125 7.49 6.1775 6.9875 6.245 6.5H9.755C9.8225 6.9875 9.875 7.49 9.875 8C9.875 8.51 9.8225 9.005 9.755 9.5ZM9.9425 13.67C10.3925 12.8375 10.7375 11.9375 10.9775 11H13.19C12.4634 12.2512 11.3106 13.199 9.9425 13.67V13.67ZM11.27 9.5C11.33 9.005 11.375 8.51 11.375 8C11.375 7.49 11.33 6.995 11.27 6.5H13.805C13.925 6.98 14 7.4825 14 8C14 8.5175 13.925 9.02 13.805 9.5H11.27Z" />{' '}
                  </svg>
                  <span className="font-display dark:text-white text-jacarta-700 mt-1 text-sm">
                    {t('header:profile-menu.language')}
                  </span>
                </div>
              </a>
              {/* Language dropdown */}
              <div
                className={` ${isActive ? ' visible' : 'invisible'}  dark:bg-dark-navy
                !-right-2 !left-auto z-10
                min-w-[14rem] whitespace-nowrap
                rounded-xl bg-white
              
                before:absolute before:-top-3 before:h-3 before:w-full
                lg:absolute lg:grid lg:!translate-y-4 lg:py-4 lg:px-2
                lg:shadow-2xl `}
              >
                <a className="pl-4 py-2 cursor-pointer" onClick={(e) => closeDropdown(e)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1em"
                    height="1em"
                    preserveAspectRatio="xMidYMid meet"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="currentColor"
                      d="m10.875 19.3l-6.6-6.6q-.15-.15-.213-.325Q4 12.2 4 12t.062-.375q.063-.175.213-.325l6.6-6.6q.275-.275.687-.288q.413-.012.713.288q.3.275.313.687q.012.413-.288.713L7.4 11h11.175q.425 0 .713.287q.287.288.287.713t-.287.712Q19 13 18.575 13H7.4l4.9 4.9q.275.275.288.7q.012.425-.288.7q-.275.3-.7.3q-.425 0-.725-.3Z"
                    />
                  </svg>
                </a>
                <a
                  onClick={(e) => {
                    setLanguage && setLanguage('en');
                    closeDropdown(e);
                  }}
                  className="dark:hover:bg-jacarta-600 hover:text-accent justify-between focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors cursor-pointer "
                >
                  <span className="font-display dark:text-white text-jacarta-700 mt-1 text-sm">
                    English
                  </span>
                  {language === 'en' ? (
                    <span>
                      <Image width={16} height={16} src={'/check.png'} alt="check"></Image>
                    </span>
                  ) : null}
                </a>
                <a
                  onClick={(e) => {
                    setLanguage && setLanguage('id');
                    closeDropdown(e);
                  }}
                  className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center justify-between space-x-2 rounded-xl px-5 py-2 transition-colors cursor-pointer"
                >
                  <span className="font-display dark:text-white text-jacarta-700 mt-1 text-sm">
                    Bahasa
                  </span>
                  {language === 'id' ? (
                    <span>
                      <Image width={16} height={16} src={'/check.png'} alt="check"></Image>
                    </span>
                  ) : null}
                </a>
              </div>
              <a
                onClick={() => {
                  signOut();
                  notifySignout();
                }}
                className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors cursor-pointer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  className="fill-jacarta-700 h-4 w-4 transition-colors dark:fill-white"
                >
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path d="M9.00147 1.45852V7.2992H15.7004L14.1503 5.78502C14.0357 5.67343 13.9661 5.52539 13.954 5.36788C13.942 5.21037 13.9883 5.05388 14.0846 4.92692L14.1503 4.85314C14.2647 4.74171 14.4163 4.67405 14.5776 4.66244C14.7388 4.65084 14.8989 4.69607 15.0289 4.7899L15.1045 4.85314L17.8022 7.48628C17.9165 7.59781 17.9861 7.74568 17.9981 7.90299C18.0102 8.0603 17.964 8.21661 17.8679 8.3435L17.8022 8.41728L15.1054 11.0548C14.9849 11.1719 14.8236 11.2403 14.6537 11.2463C14.4838 11.2524 14.3178 11.1957 14.1888 11.0875C14.0599 10.9794 13.9776 10.8278 13.9582 10.6629C13.9389 10.4981 13.984 10.3322 14.0846 10.1985L14.1494 10.1247L15.6914 8.61665H9.00237L9.00147 14.5416C9.00139 14.6378 8.97974 14.7327 8.93806 14.8198C8.89637 14.9069 8.83566 14.984 8.76017 15.0458C8.68469 15.1076 8.59627 15.1525 8.50111 15.1774C8.40595 15.2022 8.30636 15.2065 8.20934 15.1898L0.558091 13.8715C0.401683 13.8446 0.259986 13.7648 0.157913 13.6461C0.05584 13.5274 -7.45824e-05 13.3774 7.46646e-08 13.2224V2.68462C2.38112e-06 2.5285 0.0568388 2.37744 0.160374 2.25841C0.263909 2.13937 0.407412 2.06008 0.565292 2.03468L8.21654 0.808578C8.31319 0.793032 8.41214 0.798191 8.50653 0.823696C8.60093 0.849202 8.6885 0.894443 8.76318 0.95628C8.83786 1.01812 8.89786 1.09507 8.93901 1.1818C8.98016 1.26852 9.00147 1.36295 9.00147 1.45852ZM5.85276 7.73396C5.61343 7.73396 5.3839 7.82673 5.21467 7.99185C5.04543 8.15698 4.95036 8.38093 4.95036 8.61445C4.95036 8.84798 5.04543 9.07193 5.21467 9.23706C5.3839 9.40218 5.61343 9.49495 5.85276 9.49495C6.09209 9.49495 6.32162 9.40218 6.49085 9.23706C6.66008 9.07193 6.75515 8.84798 6.75515 8.61445C6.75515 8.38093 6.66008 8.15698 6.49085 7.99185C6.32162 7.82673 6.09209 7.73396 5.85276 7.73396ZM9.90162 13.8847H10.5902L10.682 13.8785C10.8438 13.8569 10.9921 13.7787 11.0993 13.6586C11.2066 13.5384 11.2656 13.3844 11.2653 13.2251L11.259 9.49231H9.90162V13.8838V13.8847ZM9.90342 6.41739L9.90162 5.29756V2.0259H10.5722C10.7352 2.02588 10.8927 2.0834 11.0157 2.18785C11.1386 2.2923 11.2187 2.43662 11.241 2.59416L11.2473 2.68287L11.2536 6.41739H9.90342V6.41739Z" />{' '}
                </svg>
                <span className="font-display dark:text-white text-jacarta-700 mt-1 text-sm">
                  {t('header:profile-menu.sign-out')}
                </span>
              </a>
            </div>
          </div>

          {/* <!-- Wallet --> */}
          {/* <!-- Dark Mode --> */}
          <button
            className="border-jacarta-100 js-dark-mode-trigger ml-2 flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15]"
            aria-label="dark"
            onClick={theme}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              className="fill-dark-navy dark-mode-light h-4 w-4 transition-colors group-hover:fill-white group-focus:fill-white dark:hidden"
            >
              <path fill="none" d="M0 0h24v24H0z"></path>
              <path d="M11.38 2.019a7.5 7.5 0 1 0 10.6 10.6C21.662 17.854 17.316 22 12.001 22 6.477 22 2 17.523 2 12c0-5.315 4.146-9.661 9.38-9.981z"></path>
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              className="fill-dark-navy dark-mode-dark hidden h-4 w-4 transition-colors group-hover:fill-white group-focus:fill-white dark:block dark:fill-white "
            >
              <path fill="none" d="M0 0h24v24H0z"></path>
              <path d="M12 18a6 6 0 1 1 0-12 6 6 0 0 1 0 12zM11 1h2v3h-2V1zm0 19h2v3h-2v-3zM3.515 4.929l1.414-1.414L7.05 5.636 5.636 7.05 3.515 4.93zM16.95 18.364l1.414-1.414 2.121 2.121-1.414 1.414-2.121-2.121zm2.121-14.85l1.414 1.415-2.121 2.121-1.414-1.414 2.121-2.121zM5.636 16.95l1.414 1.414-2.121 2.121-1.414-1.414 2.121-2.121zM23 11v2h-3v-2h3zM4 11v2H1v-2h3z"></path>
            </svg>
          </button>
          {/* Notification  */}
          {token ? <Notification user={user} /> : null}
        </div>
      </div>
    </>
  );
};

export default MblNavbar;
